import { render, staticRenderFns } from "./organization-risk-history.vue?vue&type=template&id=108e394f&scoped=true&"
import script from "./organization-risk-history.vue?vue&type=script&lang=js&"
export * from "./organization-risk-history.vue?vue&type=script&lang=js&"
import style0 from "./organization-risk-history.vue?vue&type=style&index=0&id=108e394f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108e394f",
  null
  
)

export default component.exports